export type ResourceArticle = {
  path: string;
  title: string;
  description: string;
  category: 'Start here' | 'Paddiq Link' | 'Sessions' | 'Team and garage';
};

export const RESOURCE_ARTICLES: ResourceArticle[] = [
  {
    path: '/resources/paddiq-link',
    title: 'Connect MyChrons with Paddiq Link',
    description:
      'Install on Mac or Windows, add a MyChron, upload sessions, and troubleshoot syncing.',
    category: 'Paddiq Link',
  },
  {
    path: '/resources/paddiq-link-sessions',
    title: 'Choose sessions and manage syncing in Link',
    description: 'Assign runs, set automatic uploads, pause syncing, and search Paddiq.',
    category: 'Paddiq Link',
  },
  {
    path: '/resources/paddiq-link-file-copies',
    title: 'Save Link session files to a folder',
    description: 'Choose local storage, apply naming rules, and retry pending copies.',
    category: 'Paddiq Link',
  },
  {
    path: '/resources/paddiq-link-race-studio',
    title: 'Use Race Studio with Paddiq Link',
    description:
      'Import, export, match names, and automatically register MyChron downloads on Windows.',
    category: 'Paddiq Link',
  },
  {
    path: '/resources/paddiq-link-troubleshooting',
    title: 'Update and troubleshoot Paddiq Link',
    description: 'Install updates and recover Wi-Fi connections and waiting uploads.',
    category: 'Paddiq Link',
  },
  {
    path: '/resources/getting-started',
    title: 'Getting started on the web',
    description: 'Set up a driver, vehicle, and first session.',
    category: 'Start here',
  },
  {
    path: '/resources/import-mychron-iphone',
    title: 'Import MyChron on iPhone',
    description: 'Download, assign, and upload trackside.',
    category: 'Start here',
  },
  {
    path: '/resources/account-access',
    title: 'Sign in and recover access',
    description: 'Reset a password or finish an invited account.',
    category: 'Start here',
  },
  {
    path: '/resources/session-billing',
    title: 'Understand session billing',
    description: 'Review free uploads, monthly usage, and payment access.',
    category: 'Start here',
  },
  {
    path: '/resources/product-updates',
    title: 'See product updates',
    description: 'Read verified improvements available in Paddiq.',
    category: 'Start here',
  },
  {
    path: '/resources/upload-mychron-session',
    title: 'Upload a MyChron session',
    description: 'Prepare a file and confirm its context.',
    category: 'Sessions',
  },
  {
    path: '/resources/compare-laps-and-traces',
    title: 'Compare laps and traces',
    description: 'Find differences in speed, turns, braking, and coasting.',
    category: 'Sessions',
  },
  {
    path: '/resources/fastest-recorded-lap',
    title: 'Use the fastest recorded lap',
    description: 'Overlay the driver’s best valid lap for the exact circuit.',
    category: 'Sessions',
  },
  {
    path: '/resources/use-leaderboard',
    title: 'Use the Leaderboard',
    description: 'Review best laps, time gaps, and vehicle setups.',
    category: 'Sessions',
  },
  {
    path: '/resources/analyze-sessions-iphone',
    title: 'Analyze sessions on iPhone',
    description: 'Compare laps, traces, turn speeds, and map overlays.',
    category: 'Sessions',
  },
  {
    path: '/resources/troubleshoot-sessions-iphone',
    title: 'Troubleshoot sessions on iPhone',
    description: 'Recover missing sessions, maps, laps, traces, and turns.',
    category: 'Sessions',
  },
  {
    path: '/resources/troubleshoot-session-uploads',
    title: 'Troubleshoot session uploads',
    description: 'Resolve file, access, assignment, and lap issues.',
    category: 'Sessions',
  },
  {
    path: '/resources/set-up-circuit-laps',
    title: 'Set up circuit laps',
    description: 'Match a circuit and generate useful laps.',
    category: 'Sessions',
  },
  {
    path: '/resources/add-team-members',
    title: 'Add drivers and team members',
    description: 'Choose account types and invite people safely.',
    category: 'Team and garage',
  },
  {
    path: '/resources/add-vehicle-setup',
    title: 'Add a vehicle and setup',
    description: 'Create a vehicle and preserve setup context.',
    category: 'Team and garage',
  },
];

export const RESOURCE_CATEGORIES: ResourceArticle['category'][] = [
  'Start here',
  'Paddiq Link',
  'Sessions',
  'Team and garage',
];

type ResourceSidebarProps = {
  currentPath: string;
};

export function ResourceSidebar({ currentPath }: ResourceSidebarProps) {
  return (
    <nav className="resource-sidebar" aria-label="Resource articles">
      <a className="resource-sidebar__all" href="/resources">
        <span aria-hidden="true">←</span> All resources
      </a>
      {RESOURCE_CATEGORIES.map((category) => (
        <div className="resource-sidebar__group" key={category}>
          <p>{category}</p>
          <ul>
            {RESOURCE_ARTICLES.filter((article) => article.category === category).map((article) => (
              <li key={article.path}>
                <a
                  className={article.path === currentPath ? 'is-current' : undefined}
                  href={article.path}
                  aria-current={article.path === currentPath ? 'page' : undefined}
                >
                  {article.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}
